import { useState } from "react";
import { InView } from "react-intersection-observer";
import { RecommendItemsToUser } from "recombee-js-api-client";
import posthog from "posthog-js";
import { useQuery } from "@tanstack/react-query";

import useAppSelector from "@/hooks/useAppSelector";
import { recombeeClient } from "@/recourses/recombee";
import { recombeeToCart } from "@/utils/product";
import type { RecombeeValuesItemUser } from "@/types/recombee";
import useSessionContext from "@/hooks/useSesionContext";
import SwiperSectionProductGalleryXL from "@/components/Organisms/SwiperSectionProductGalleryXL";

const BestSeller = () => {
  const { isAthenticated } = useSessionContext();
  const storeId = useAppSelector((state) => state.cart.storeId);
  const userID = posthog.get_distinct_id();
  const [inView, setInView] = useState(false);

  const {
    data: bestSeller,
    error,
    isFetching,
    isFetched,
  } = useQuery({
    queryKey: ["bestSellerProducts", storeId, userID, isAthenticated()],
    queryFn: async () => {
      const response = await recombeeClient.send(
        new RecommendItemsToUser("top-seller", 20, {
          scenario: "top_sellers",
          returnProperties: true,
          cascadeCreate: true,
          filter: `'store_id' == "${storeId}" AND 'product_availability_available_online' == true`,
        })
      );

      const items: Cart[] = response.recomms.map((recom) =>
        recombeeToCart(Number(recom.id), storeId!, recom.values as unknown as RecombeeValuesItemUser)
      );

      return {
        items,
        id: response.recommId,
      };
    },
    enabled: !!userID && !!storeId && inView,
  });

  if (error) {
    return null;
  }

  if (isFetching || !storeId || !userID || (!inView && !isFetched)) {
    return (
      <InView
        onChange={(isView) => {
          if (!inView) setInView(isView);
        }}
        rootMargin="1500px 0px"
        triggerOnce
      >
        <SwiperSectionProductGalleryXL items={[]} oldDataItems={[]} isLoading />
      </InView>
    );
  }

  if (bestSeller?.items && bestSeller?.items.length <= 0) {
    return null;
  }

  return (
    <SwiperSectionProductGalleryXL
      items={bestSeller?.items ?? []}
      title={"Lo más vendido"}
      recommId={bestSeller?.id}
    />
  );
};

export default BestSeller;
